import axios, { AxiosResponse } from "axios";
import { allowOnly200 } from "../helpers/constants";
import { AccessTokenResponse, IApiPasswordOptions } from "./types";
import { setTokenFromResponse } from "../helpers/setTokenFromResponse";
import tokenHelper from "../helpers/tokenStorage";

export const authenticateWithMicrosoft = async (
  code: string | boolean,
  codeVerifier: string | null
): Promise<AxiosResponse<AccessTokenResponse>> => {
  return axios.post<AccessTokenResponse>(
    "/api/accounts/login/microsoft",
    {
      AppId: "Default",
      Code: code,
      CodeVerifier: codeVerifier,
      RedirectUri: process.env.REACT_APP_REDIRECTURL,
    },
    {
      validateStatus: allowOnly200,
    }
  );
};

export const authenticateWithPassword = async (
  email: string,
  password: string
): Promise<void> => {
  try {
  const resp = await axios.post<AccessTokenResponse>(
      "/api/accounts/login",
      {
        AppId: "Admin",
        EmailAddress: email,
        Password: password,
      },
      {
        validateStatus: allowOnly200,
      }
    );

    setTokenFromResponse(resp.data);
    return Promise.resolve();
  } catch(ex) {
    return Promise.reject(ex);
  }
};

export const refreshToken = async (): Promise<void> => {
  const resp = await axios.post<AccessTokenResponse>(
    "/api/accounts/login/refresh",
    {
      RefreshToken: tokenHelper.refreshToken,
    }
  );

  setTokenFromResponse(resp.data);
};

export const forgotPassword = async (email: string | undefined) => {
  await axios({
    method: "post",
    url: "/api/accounts/password/forgot",
    data: {
      EmailAddress: email,
    },
    validateStatus: allowOnly200,
  });
};

export async function resetPassword(
  userId: string,
  newPassword: string,
  resetToken: string | boolean
) {
  await axios({
    method: "post",
    url: "/api/accounts/password/reset",
    data: {
      userId: userId,
      Password: newPassword,
      ResetToken: resetToken,
    },
    validateStatus: allowOnly200,
  });
}

export const changePassword = async (
  oldPass: string,
  newPass: string
): Promise<AxiosResponse<void>> => {
  return axios({
    method: "post",
    url: "/api/accounts/password/change",
    data: {
      OldPassword: oldPass,
      NewPassword: newPass,
      ConfirmNewPassword: newPass,
    },
    validateStatus: allowOnly200,
  });
};

export const getPasswordValidationRequirements = async (): Promise<
  AxiosResponse<IApiPasswordOptions>
> => {
  return axios.get("/api/accounts/password/options");
};

export const reSendActivationEmail = async (
  UserId: string
): Promise<AxiosResponse<void>> => {
  return axios.post(`/api/accounts/organization/users/signup/resend`, { UserId, });
};
